import TriggerSerializer from 'eflex/serializers/trigger';

export default class WorkInstructionHardwareTriggerSerializer extends TriggerSerializer {}
